import { render } from "./DepotDetails.vue?vue&type=template&id=b19d1f72"
import script from "./DepotDetails.vue?vue&type=script&lang=js"
export * from "./DepotDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__